import { render, staticRenderFns } from "./WhatsNewPanel.vue?vue&type=template&id=5e5b74c8&"
import script from "./WhatsNewPanel.vue?vue&type=script&lang=ts&"
export * from "./WhatsNewPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e5b74c8')) {
      api.createRecord('5e5b74c8', component.options)
    } else {
      api.reload('5e5b74c8', component.options)
    }
    module.hot.accept("./WhatsNewPanel.vue?vue&type=template&id=5e5b74c8&", function () {
      api.rerender('5e5b74c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/components/WhatsNewPanel/WhatsNewPanel.vue"
export default component.exports